import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LabelXs, TextM } from '../../../../../infra/dls/components/typography';
import { Radio } from '../../../../../infra/dls/components/radio/radio';
import styles from './styles.module.scss';
var sortLabels = {
    createdAtDesc: 'Newest first',
    createdAtAsc: 'Oldest first',
    successDesc: 'Most successful',
    displayNameAsc: 'Alphabetical',
};
export var SortGroup = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return (_jsxs("div", { className: styles['section-wrapper'], children: [_jsx(LabelXs, { color: "secondary", className: "text-uppercase", children: "Sort by" }), _jsx("div", { className: styles.group, children: Object.keys(sortLabels).map(function (key) {
                    var sortKey = key;
                    return (_jsx(Radio, { id: "radio-sort-".concat(sortKey), name: "campaign-sort", checked: value === sortKey, onChange: function (checked) { return checked && onChange(sortKey); }, children: _jsx(TextM, { color: "primary", children: sortLabels[sortKey] }) }, sortKey));
                }) })] }));
};
